<template>
  <div>
    <direct-edit
      :_search-cond="_searchCond"
      :is-search="isSearch"
      :is-valid="isValid"
      :is-meihen="isMeihen"
      :is-hikitori="isHikitori"
      @reset="onReset"
      @setInvalid="onSetInvalid"
      @setData="onSetData"
      @loaded="onLoaded"
      @searched="onSearched"
    />
    <div v-if="!isDialog" class="mt-2 mr-2 text-right">
      <md-checkbox class="md-primary" v-model="isOkiniiri">
        お気に入りに保存する
      </md-checkbox>
    </div>
  </div>
</template>

<script>
import DirectEdit from '@/components/order/DirectEdit'
import Mixin from '../mixin/Mixin'

const DATA_KBN_AA = 'AUCTION'
export default {
  name: 'OrderDirect',

  components: {
    DirectEdit,
  },

  mixins: [Mixin],

  props: {
    /** 検索条件 */
    _searchCond: {
      type: Object,
      default: null,
    },

    /** 検索実行フラグ */
    isSearch: {
      type: Boolean,
      default: false,
    },

    /** バリデーション実行フラグ */
    isValid: {
      type: Boolean,
      default: false,
    },

    /** お気に入りフラグ */
    isOkiniiri: {
      type: Boolean,
      default: false,
    },

    /** Dialog内に表示するか */
    isDialog: {
      type: Boolean,
      default: false,
    },

    /** 名変フラグ */
    isMeihen: {
      type: Number,
      default: 0,
    },

    /** 引取先フラグ */
    isHikitori: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    /** POS番号を設置する */
    setPosBango(aaCd) {
      var conditions = { type: 'AA_CD', AA_CD: aaCd }
      this.getLastJyucyu(conditions).then((res) => {
        if (res.data) {
          const data = res.data.navi_jyuchu
          let posBango = ''
          if (aaCd === data.HIKITORI_AA_CD) {
            posBango = data.HIKITORI_AA_POS_BANGO
          } else {
            posBango = data.NOSYA_AA_POS_BANGO
          }
          this.$emit('setPosBango', posBango)
        }
      })
    },

    /** リセット完了通知 */
    onReset(type) {
      this.$emit('reset', type)
    },

    /** バリデーション結果通知 */
    onSetInvalid(val, type) {
      this.$emit('setInvalid', val, type)
    },

    /** 入力データ通知 */
    onSetData(val, type) {
      if (type === DATA_KBN_AA) this.setPosBango(val.AA_CD)
      this.$emit('setData', val, type)
    },

    /** Loadingフラグ通知 */
    onLoaded(val, type) {
      this.$emit('loaded', val, type)
    },

    /** 検索完了通知 */
    onSearched(type) {
      this.$emit('searched', type)
    },
  },

  watch: {
    /** お気に入り選択フラグ通知 */
    isOkiniiri() {
      this.$emit('setIsOkiniiri', this.isOkiniiri)
    },
  },
}
</script>

<style lang="sass" scoped>
.md-checkbox
  margin: 0
</style>



// WEBPACK FOOTER //
// src/components/order/Direct.vue